.form-subtitle {
  margin-bottom: 22px;
}

.form-section {
  margin-bottom: 32px;
}
